export default "__VITE_ASSET__ByM0qTid__"